import { SchoolLogo } from 'features/SchoolLogo';
import { LogoLink } from 'shared/components/LogoLink';

import { SchoolLogoWrapper } from './components/SchoolLogoWrapper';

import type { FC } from 'react';
import type { LogoLinkProps } from 'shared/components/LogoLink';

type SchoolSectionProps = Pick<LogoLinkProps, 'onClick'>;

export const SchoolSection: FC<SchoolSectionProps> = ({ onClick }) => (
  <SchoolLogoWrapper>
    <LogoLink onClick={onClick}>
      <SchoolLogo />
    </LogoLink>
  </SchoolLogoWrapper>
);
